import gamepad from '~/assets/icons/gamepad.svg';
// import docs from '~/assets/icons/docs_2.svg';
import puzzle from '~/assets/icons/puzzle.svg';

export enum StatsMenu {
	Skills = 'skills',
	Main = 'main',
	// Documents = 'documents',
}

export const statsMenuNames = {
	[StatsMenu.Skills]: 'Навыки',
	[StatsMenu.Main]: 'Основная',
	// [StatsMenu.Documents]: 'Документы',
};

export const statsMenuIcons = {
	[StatsMenu.Skills]: puzzle,
	[StatsMenu.Main]: gamepad,
	// [StatsMenu.Documents]: docs,
};
